<div class="inbuilt-card-v2-wrapper">
  <div class="card-loader" *ngIf="loading" aria-live="polite" aria-busy="true">
    <div class="spinner"></div>
    <div class="loader-text">Loading card data...</div>
  </div>

  <div class="card-no-data" *ngIf="!loading && noDataFound">No data found.</div>

  <div class="inbuilt-card-v2" *ngIf="!loading && !noDataFound">
    <p class="total-value">{{ totalDisplayValue }}</p>

    <hr class="value-divider" />

    <p class="detail-row" *ngFor="let detail of details">
      <span class="detail-head">
        <span class="detail-label">{{ detail.label }}</span>
        <span class="detail-separator"> : </span>
      </span>
      <span class="detail-tail">
        <span class="detail-value">{{ detail.formattedValue }}</span>
        <span class="detail-percentage"
          [ngClass]="{
            'percentage-up': getPercentDirection(detail.percentage) === 'up',
            'percentage-down': getPercentDirection(detail.percentage) === 'down',
            'percentage-neutral': getPercentDirection(detail.percentage) === 'neutral'
          }">
          <ng-container [ngSwitch]="getPercentDirection(detail.percentage)">
            <span *ngSwitchCase="'up'" class="percentage-arrow" aria-hidden="true">&uarr;</span>
            <span *ngSwitchCase="'down'" class="percentage-arrow" aria-hidden="true">&darr;</span>
            <span *ngSwitchDefault class="percentage-arrow" aria-hidden="true">&rarr;</span>
          </ng-container>
          ({{ formatPercentValue(detail.percentage) }})
        </span>
      </span>
    </p>
  </div>
</div>
